<template>
  <div id="page" :class="{fixed: confirmDialog}">
    <div class="app-content" :class="{show: show}">
      <div class="banner" v-if="officialActivityBanner"><img :src="officialActivityBanner" alt=""></div>
      <div class="activity-category">
        <span v-for="item in category" :key="item.typeId" :class="{cur: categoryId === item.typeId}" @click="onChangeCategory(item.typeId)">{{ item.name }}</span>
      </div>
      <div class="activity-items" v-infinite-scroll="getDhccActivity" infinite-scroll-disabled="busy" infinite-scroll-distance="20">
        <div class="item" v-for="item in activity" @click="onDetail(item)">
          <div class="image" :style="{backgroundImage: 'url(' + item.mainImg +')'}"></div>
          <div class="title">{{item.title}}</div>
          <div class="desc" v-if="item.description">
            <div v-html="item.description"></div>
          </div>
          <div class="date">
            <span class="icon"><i class="iconfont icon-riqi"></i></span>
            <span>活动时间：{{ moment(item.starttime).format('YYYY年MM月DD日') }} ~ {{ moment(item.endtime).format('YYYY年MM月DD日') }}</span>
          </div>
          <div class="foot-wrap">
            <div class="subtitle" v-if="item.subtitle"><span class="label">最高奖励</span><span class="text">{{item.subtitle}}</span></div>
            <div v-else></div>
            <div class="btn">参加活动</div>
          </div>
        </div>
      </div>
      <div class="empty" v-if="!activity.length">
        <img src="http://cdn.uviewui.com/uview/empty/data.png" alt="">
        <span class="text">暂无活动</span>
      </div>
      <transition name="fade">
        <div v-if="showLoading">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
            <p class="weui-toast__content">加载中...</p>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast weui-toast_text">
            <p class="weui-toast__content">{{toastMsg}}</p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="less" scoped>
#page {
  min-height: 100vh;
}
.app-content {
  height: 100vh;
  overflow-y: auto;
  opacity: 0;
  transition: opacity 0.2s ease;
  background-color: #f7f7f7;
}
.app-content.show {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.2s;
}

.banner {
  padding: 0.2rem;
  min-height: 2.6rem;
}

.activity-category {
  padding: 0 0.4rem;
  height: 0.82rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #777;
  font-weight: 500;
  font-size: 0.28rem;
  span {
    position: relative;
    height: 0.82rem;
    line-height: 0.82rem;
    &.cur {
      color: #000;
      &:after {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 3px;
        border-radius: 4px;
        background-color: #e83836;
        content: '';
      }
    }
  }
}

.activity-items {
  padding: 0.4rem 0.4rem 0;
  .item {
    background: #fff;
    border-radius: 0.16rem;
    margin-bottom: 0.4rem;
    overflow: hidden;
    .image {
      background-repeat: no-repeat;
      background-position: center 0;
      background-size: cover;
      height: 2.35rem;
      overflow: hidden;
    }
    .date {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0.1rem 0.2rem;
      color: #e40400;
      font-size: 0.26rem;
      .icon {
        padding-right: 0.1rem;
        .iconfont {
          font-size: 0.26rem;
        }
      }
    }
    .title {
      padding: 0.2rem 0.2rem 0;
      font-size: 0.34rem;
      font-weight: 500;
    }
    .desc {
      padding: 0.1rem 0.2rem;
      font-size: 0.26rem;
      color: #999;
    }
    .foot-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.2rem;
      margin-bottom: 0.26rem;
      .subtitle {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 0.26rem;
        background-color: #eff1fd;
        border-radius: 0.44rem;
        .label {
          color: #fff;
          height: 0.44rem;
          line-height: 0.46rem;
          overflow: hidden;
          background-color: #6178f2;
          padding: 0 0.16rem;
          border: 1px #3b57ef solid;
          border-radius: 0.44rem;
        }
        .text {
          height: 0.44rem;
          line-height: 0.46rem;
          overflow: hidden;
          color: #3250ee;
          padding: 0 0.22rem;
        }
      }
      .btn {
        height: 0.56rem;
        line-height: 0.58rem;
        border-radius: 0.56rem;
        padding: 0 0.24rem;
        color: #fff;
        font-size: 0.28rem;
        background-image: linear-gradient(to right, #e7486d , #e93325);
        overflow: hidden;
      }
    }
  }
}

.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  img {
    width: 240px;
  }
  .text {
    font-size: 0.30rem;
    color: #999;
  }
}

</style>

<script>
import request from "../utils/request";
import gfRequest from "../utils/gfRequest";
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      show: false,
      showLoading: true,
      confirmDialog: false,
      showToast: false,
      checkUserInfo: false,
      userInfo: {},
      category: [{
        name: '淘宝',
        typeId: 1,
      }, {
        name: '京东',
        typeId: 3,
      }, {
        name: '拼多多',
        typeId: 4,
      }, {
        name: '唯品会',
        typeId: 9,
      },{
        name: '考拉',
        typeId: 11,
      }, {
        name: '苏宁',
        typeId: 12,
      }],
      categoryId: 1,
      activity: [],
      pageIndex: 1,
      pageTotal: 1,
      busy: false,
      officialActivityBanner: null,
      appEnv: {
        prod: true,
        appId: '',
      },
    };
  },
  created() {
    this.appEnv.prod = process.env.VUE_APP_RELEASE === 'prod';
    if (!this.appEnv.prod) {
      this.appEnv.appId = 'CC202104110012172897';
      new VConsole();
    }
  },
  mounted() {
    const appId = this.$route.query.appid ||'';
    const uid = this.$route.query.uid || 0;

    if (appId) this.appEnv.appId = appId;
    if (uid) this.userInfo.id = parseInt(uid, 10);
    if (!this.appEnv.appId) {
      this.showLoading = false;
      this.show = true;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }

    request({
      url: `/open/api/sys/conf`,
      method: 'GET',
    }).then((resp) => {
      const globalConfig = resp.list || []
      for (const conf of globalConfig) {
        if (conf.field === 'OfficialActivityBanner') {
          this.officialActivityBanner = conf.value
        }
      }
    }).catch(err => {})

    const h5Userinfo = getH5UserInfo();
    if (h5Userinfo) {
      new Promise(async () => {
        await h5Userinfo.then((resp) => {
          this.checkUserInfo = true;
          this.userInfo = JSON.parse(resp);
        }).catch(() => {});
        this.showLoading = true;
        this.show = true;
        await this.getDhccActivity().catch(err => {});
      })
    } else {
      if (!this.appEnv.prod) {
        this.showLoading = true;
        new Promise(async () => {
          this.show = true;
          await this.getDhccActivity().catch(err => {});
        });
      } else {
        this.showLoading = false;
        this.show = true;
        this.toast('未能获取到用户信息请联系客服');
      }
    }
  },
  watch: {
  },
  methods: {
    moment,
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.checkUserInfo;
    },
    toast(v) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
    },
    async onChangeCategory(typeId) {
      this.showLoading = true;
      this.activity = [];
      this.categoryId = typeId;
      this.pageIndex = 1;
      this.pageTotal = 1;
      await this.getDhccActivity();
    },
    getDhccActivity(){
      this.showLoading = true;
      this.busy = true;
      return gfRequest({
        url: `/api/dhcc/activity`,
        method: 'GET',
        params: {appid: this.appEnv.appId, typeId: this.categoryId, pageSize: 10, pageIndex: this.pageIndex},
      }).then((res) => {
        const activity = (res.data.list || []).map( t => {
          t.description = t.description.replace(/\r\n/g,"，").replace(/\s+/g,'')
          return t;
        })
        this.activity = this.activity.concat(activity)
        if (this.pageTotal === 1 && res.data.pagination.total > 0) {
          this.pageTotal = Math.ceil(res.data.pagination.total / res.data.pagination.pageSize)
        }
        if (this.pageIndex < this.pageTotal) {
          this.pageIndex++;
          this.busy = false
        }
        setTimeout(() => {
          this.showLoading = false;
        }, 250)
      }).catch(err => {})
    },
    onDetail(activity) {
      openTkAct({
        actId: activity.activityData,
        type: activity.type
      })
    }
  }
}
</script>
